import { InfoNotice } from '@/components/patterns/info-notice'
import { ShieldAlert } from 'lucide-react'

export function StockImageLicensingNotice({ compact = false }) {
  return (
    <InfoNotice
      title="Image licensing responsibility"
      tone="warning"
      compact={compact}
      icon={<ShieldAlert />}
    >
      Before uploading or publishing a stock image, confirm that you understand its licensing
      requirements and have the legal right to use it for commercial business purposes.
    </InfoNotice>
  )
}
